import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Pricing Penguin';
const SITE_URL = 'https://www.pricingpenguin.co.uk';
const DEFAULT_DESCRIPTION = 'Explore a modelled budget for your home improvement project, clarify its scope and browse tradesperson profiles. Availability varies by trade and area.';
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

// iOS Smart App Banner (Safari). On by default for every page that renders
// SEO; the chat page opts out because the banner pushes the viewport down and
// breaks its full-height layout. Helmet only runs at prerender time in
// production, so this lands in the static head of each prerendered route.
const APP_STORE_ID = '6755680360';

const SEO = ({
  title,
  description,
  noindex = false,
  nofollow = false,
  canonical,
  type = 'website',
  image,
  appBanner = true,
}) => {
  const robotsContent = [
    noindex ? 'noindex' : 'index',
    nofollow ? 'nofollow' : 'follow'
  ].join(', ');

  // Same rule as scripts/inject-static-seo.js: add the brand suffix only when
  // it still fits inside Google's ~60-character SERP title. These two must
  // agree, or the prerendered head and the client-rendered head disagree on the
  // same page.
  const titleSuffix = ` | ${SITE_NAME}`;
  const pageTitle = title
    ? (title.includes(SITE_NAME) || title.length + titleSuffix.length > 60
        ? title
        : `${title}${titleSuffix}`)
    : `${SITE_NAME} — AI-Powered Home Improvement Quotes`;
  const pageDescription = description || DEFAULT_DESCRIPTION;
  const pageImage = image || DEFAULT_IMAGE;
  const pageCanonical = canonical || (typeof window !== 'undefined' ? `${SITE_URL}${window.location.pathname}` : SITE_URL);

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="robots" content={robotsContent} />
      <link rel="canonical" href={pageCanonical} />
      {appBanner && (
        <meta name="apple-itunes-app" content={`app-id=${APP_STORE_ID}`} />
      )}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:url" content={pageCanonical} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />
    </Helmet>
  );
};

export default SEO;
